
/* eslint no-underscore-dangle:  0 */
/* eslint-disable no-debugger, no-console */
/* eslint-disable */
import React, { useEffect } from 'react';
import { Document, Page, Text, View, StyleSheet, Font } from '@react-pdf/renderer';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';

// Define fonts to be used in the document
Font.register({
  family: 'Roboto',
  src: 'https://fonts.gstatic.com/s/roboto/v20/KFOmCnqEu92Fr1Mu4mxP.ttf',
});

// Define the transaction data
// const transactions = [
//     { id: 1, amount: 100, pin: 1234, type: 'debit' },
//     { id: 2, amount: 200, pin: 5678, type: 'credit' },
//     { id: 3, amount: 50, pin: 9012, type: 'debit' },
// ];

// Define the styles for the table
const styles = StyleSheet.create({
  table: {
    display: 'table',
    width: '95%',
    border: '1px solid #bfbfbf',
    borderCollapse: 'collapse',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '20px',

  },
  tableRow: {
    display: 'flex',
    flexDirection: 'row',

    // border: '1px solid #bfbfbf',
    justifyContent: 'space-between',
  },
  tableColHeader: {
    display: 'table-row',
    textAlign: 'left',
    backgroundColor: 'white',
    color: 'black',
    fontWeight: 'bold',
    paddingTop: "12px",
    fontSize: "14px",
    paddingBottom: "12px",
    paddingLeft: "8px",
    paddingRight: "8px",
    textAlign: 'center',
    // borderStyle: 'solid',
    // border: '1px solid #bfbfbf',

  },
  tableColEven: {
    display: 'table-row',
    flexGrow: 1,
    textAlign: 'center',
    fontSize: "12px",
    backgroundColor: '#e6e6e6',
    // border: '1px solid #ddd',
    padding: "8px",


  },
  tableColOdd: {
    display: 'table-row',
    flexGrow: 1,
    textAlign: 'center',
    fontSize: "12px",
    backgroundColor: 'white',
    // border: '1px solid #ddd',
    padding: "8px",
  },
  container:{
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '90%',
    paddingTop: '10px',
    marginLeft: 'auto',
    marginRight: 'auto',
    

  },
  button: {
    backgroundColor: '#E53471',
    width: '100px',
    borderRadius: '5px',
    border: 'none',
    height: '20px',
    color: 'white',
    // padding: '10px 10px',
    textAlign: 'center',
    textDecoration: 'none',
    display: 'inline-block',
    fontSize: '16px',
    fontWeight: 900,
    // margin: '4px 2px',

  },
  text: {
    fontSize: '16px',
    color: 'black',
    textAlign: 'left',
    fontWeight: 'bold',

  },

});

// Define the table component
const TransactionTable = ({ transactions }) => {
    
  return (
    <View>
      <View style={styles.table}>

        <View  style={[styles.tableRow, styles.tableColHeader]}>
          <Text  style={{ flexGrow: '1', flexBasis: '5px', textAlign: 'left' }}>#</Text>
          <Text  style={{ flexGrow: '2', flexBasis: '40px', textAlign: 'left' }}>Number/Name</Text>
          <Text  style={{ flexGrow: '2', flexBasis: '10px' }} >Amount</Text>
          <Text  style={{ flexGrow: '2', flexBasis: '5px' }} >Pin</Text>
          <Text  style={{ flexGrow: '2', flexBasis: '10px' }}>Type</Text>
          <Text  style={{ flexGrow: '1', flexBasis: '15px', textAlign: 'center' }}>Date</Text>

        </View>
        {transactions?.mobileFinnance?.map((transaction, index) => (
          < >
            <View style={(index % 2 == 0) ? [styles.tableRow, styles.tableColEven] : [styles.tableRow, styles.tableColOdd]}>
              <Text style={{ flexGrow: '1', flexBasis: '5px', textAlign: 'left' }}>{(transaction?.index)}</Text>
              <Text style={{ flexGrow: '2', flexBasis: '30px', textAlign: 'left' }}>{(transaction?.number)}</Text>
              <Text style={{ flexGrow: '2', flexBasis: '10px' }} >{transaction?.amount}</Text>
              <Text style={{ flexGrow: '2', flexBasis: '5px' }} >{transaction?.pin}</Text>
              <Text style={{ flexGrow: '2', flexBasis: '10px' }}>{(transaction?.type)}</Text>
              <Text style={{ flexGrow: '1', flexBasis: '20px', textAlign: 'center' }}>{moment(transaction?.date).format('DD MMM YY')}</Text>

            </View>
          </>
        ))}


      </View>
      <View style={styles.container}>
        <View>
          <Text style={styles.text} >Total</Text>
          <Text style={styles.button}>{transactions?.totalAmmount}</Text>
        </View>
        {<View>
          <Text style={styles.text}  >Profit</Text>
          <Text style={styles.button}>{transactions?.profit}</Text>
        </View>}
        
      </View>
    </View>
  );
};

// Define the PDF document
const MyDocument = ({ transactions, service, client,singleClient }) => {


  let splited = client.split(' ');
  let clientName = splited[0];
  let clientNumber = splited[1];
  let endDate = moment(transactions?.mobileFinnance[0]?.date).format('DD MMM YY');
  let startDate = moment(transactions?.mobileFinnance[transactions?.mobileFinnance.length - 1]?.date).format('DD MMM YY');

  
  return (
    <Document>
      <Page size="A4" wrap>
        <Text  style={{ textAlign: "center", fontSize: "16px", fontWeight: "500", marginTop: "20px" }}>Transactions of {service}</Text>
        <Text  style={{ textAlign: "center", fontSize: "12px", fontWeight: "300", marginTop: "8px" }}>Name: {client === 'All Client' ? "All Client" : clientName}</Text>
        {client !== 'All Client' && <Text  style={{ textAlign: "center", fontSize: "12px", fontWeight: "300", marginTop: "8px" }}> Number: {clientNumber}</Text>}
        <Text  style={{ textAlign: "center", fontSize: "12px", fontWeight: "300", marginTop: "8px" }}>Date: {startDate} to {endDate}</Text>
        <TransactionTable transactions={transactions} />
      </Page>
    </Document>
  );
};


export default MyDocument;
